import { useState, type CSSProperties, useRef, useEffect } from 'react';

const useLineStyles = (activeKey: string, orientation: 'horizontal' | 'vertical') => {
    const tabButtonRefs = useRef<Record<string, HTMLButtonElement | null>>({});

    const [lineStyles, setLineStyles] = useState<CSSProperties>({});

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const target = entry.target as HTMLButtonElement;

                setLineStyles(
                    orientation === 'horizontal'
                        ? {
                              width: `${target.offsetWidth}px`,
                              left: `${target.offsetLeft}px`
                          }
                        : {
                              height: `${target.offsetHeight}px`,
                              top: `${target.offsetTop}px`
                          }
                );
            });
        });

        const activeTabElement = tabButtonRefs.current[activeKey];

        if (activeTabElement) {
            resizeObserver.observe(activeTabElement);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, [activeKey, orientation]);

    const register = (key: string) => (ref: HTMLButtonElement | null) => {
        tabButtonRefs.current[key] = ref;
    };

    return { lineStyles, register };
};

export default useLineStyles;
